const SIDEBAR_COLLAPSED_STORAGE_KEY = 'zoofizjo_sidebar_collapsed';
const COLLAPSED_VALUE = 'true';

export function readSidebarCollapsed(): boolean {
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === COLLAPSED_VALUE;
  } catch {
    return false;
  }
}

export function storeSidebarCollapsed(isCollapsed: boolean): void {
  try {
    if (isCollapsed) {
      window.localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, COLLAPSED_VALUE);
    } else {
      window.localStorage.removeItem(SIDEBAR_COLLAPSED_STORAGE_KEY);
    }
  } catch {
    return;
  }
}
